let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5ePFE")]).then(() => parcelRequire('8L6ZW'));